import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/contexts/AppContext";
import { Button } from "@/components/ui/button";
import { ArrowRight, MapPin, Layers, Globe2 } from "lucide-react";

export default function AboutPage() {
  const { tr, settings } = useApp();
  useEffect(() => { document.title = "About | AFC TELECOM"; }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
      <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1E5FD9]">About</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl font-bold text-[#0B132B]">{tr.about.title}</h1>
      <div className="blue-line my-8" />
      <div className="grid lg:grid-cols-[2fr_1fr] gap-12">
        <div className="space-y-6 text-lg leading-relaxed text-slate-700">
          <p>{tr.about.p1}</p>
          <p>{tr.about.p2}</p>
          <p>{tr.about.p3}</p>

          <div className="pt-4 flex flex-wrap gap-3">
            <Button asChild className="rounded-full bg-[#1E5FD9] hover:bg-[#174AB0] px-6 py-5">
              <Link to="/request-quote">{tr.hero.cta2} <ArrowRight className="w-4 h-4 ms-1" /></Link>
            </Button>
            <Button asChild variant="outline" className="rounded-full border-slate-300 hover:border-[#1E5FD9] hover:text-[#1E5FD9] px-6 py-5">
              <Link to="/phones">{tr.hero.cta1}</Link>
            </Button>
          </div>
        </div>

        <div className="space-y-4">
          {[
            { icon: MapPin, k: "Location", v: settings.location },
            { icon: Layers, k: "Focus", v: "B2B Technology Distribution" },
            { icon: Globe2, k: "Markets", v: "Regional & International" },
          ].map((it, i) => {
            const Icon = it.icon;
            return (
              <div key={i} className="border border-slate-200 rounded-2xl p-5 flex gap-4 items-start">
                <div className="w-10 h-10 rounded-xl bg-[#1E5FD9]/10 text-[#1E5FD9] flex items-center justify-center shrink-0"><Icon className="w-5 h-5" /></div>
                <div>
                  <p className="text-xs uppercase tracking-[0.2em] text-slate-500">{it.k}</p>
                  <p className="mt-1 font-display text-lg font-semibold text-[#0B132B]">{it.v}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
